import { render, staticRenderFns } from "./ProcedureListView.vue?vue&type=template&id=f4a0fc28"
import script from "./ProcedureListView.vue?vue&type=script&lang=js"
export * from "./ProcedureListView.vue?vue&type=script&lang=js"
import style0 from "./ProcedureListView.vue?vue&type=style&index=0&id=f4a0fc28&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports